const initialState = {
    songId: null,
    lyrics: [],
    status: "idle"
  };

export default initialState;